import { FC } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { NativeSelectProps, SelectProps } from './types';
import { getCustomStyles } from './config';
import { inputVariants } from './atom';

export const CustomSelectInput: FC<SelectProps<any, boolean>> = (props) => {
  const {
    label,
    width,
    height,
    isMulti = false,
    style,
    variant,
    ...res
  } = props;

  return (
    <div className="w-full">
      <label
        htmlFor={props.label}
        className="text-xs font-semibold uppercase leading-7 text-neutral-900"
      >
        {label}
      </label>
      <>
        {props.isCreatable ? (
          <CreatableSelect
            isMulti={isMulti}
            styles={getCustomStyles({
              ...width,
              ...height,
              isMulti,
              style,
              variant,
            })}
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            {...res}
          />
        ) : (
          <Select
            isMulti={isMulti}
            styles={getCustomStyles({
              ...width,
              ...height,
              isMulti,
              style,
              variant,
            })}
            {...res}
          />
        )}
      </>
    </div>
  );
};

export const NativeSelect = ({
  label,
  variant = 'primary',
  options,
  ...props
}: NativeSelectProps) => {
  return (
    <>
      {label && (
        <label
          htmlFor={props.id}
          className="mb-2 text-xs font-semibold uppercase leading-7 text-neutral-900"
        >
          {label}
        </label>
      )}
      <select
        {...props}
        className={`!relative inline-flex w-full rounded border border-gray-300 bg-transparent !p-[17px] leading-none text-gray-700 placeholder-gray-500 transition-colors duration-300 ease-in-out placeholder:text-sm focus:border-gray-500 focus:outline-none focus:ring-4 focus:ring-gray-300 focus:ring-opacity-30 ${inputVariants[variant]} ${props.className}`}
      >
        <option className="text-sm !text-neutral-600" disabled value="">
          {props.placeholder}
        </option>
        {options?.map((option) => (
          <option key={`option-${option.value}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
};
